import React, {Component} from 'react';
import Swiper from 'react-id-swiper';
import {observer, inject} from 'mobx-react';
import MetaTags from 'react-meta-tags';

@inject('store')
@observer
class Howdoes extends Component {
    constructor() {
        super()
        this.state = {
            activecl: 1,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.store.homeType(false);
        this.myTimer()
    }


    myTimer() {
        var img = 1;
        setInterval(() => {
            img = img + 1;
            if (img == 4) {
                img = 1
            }
            this.setState({activecl: img})
            this.props.mychanges(img);
        }, 5000)
    }


    render() {
        const params = {
            loop: true,
            slidesPerView: 1,
            autoplay: {delay: 5000},
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            on: {
                slideChangeTransitionStart: () => {

                },
            }
        }


        return (
            <div>
                <MetaTags>
                    <title>Revfin</title>
                    <meta name="description" content="Some description."/>
                    <meta property="og:title" content="MyApp"/>
                    <meta property="og:image" content="path/to/image.jpg"/>
                </MetaTags>
                <div className="right_app_text">
                    <h3 className="color_main d-none d-md-block d-lg-block">How the app works</h3>
                    <ul className="mgt-40 relative ultab right_app_text d-none d-md-block d-lg-block">
                        <li
                            className={`${this.state.activecl == 1 ? 'activecl' : ''}`}>
                            {/* <a href="javascript:void(0)" className="rev_media"> */}
                            <div className="rev_media">
                                <div className="media_left"><i className="one-sp"></i></div>
                                <div className="contentarea">
                                    <b className="fz-17 fw3 revfincolor">Apply</b>
                                    <p className="mgt-10 fz-12 lcolor">Download our App to complete the application
                                        process.
                                        From starting to getting a decision usually takes about
                                        10 minutes!</p>
                                </div>
                            </div>
                            {/* </a> */}
                        </li>
                        <li className={`${this.state.activecl == 2 ? 'activecl' : ''}`}>
                            {/* <a href="javascript:void(0)" className="rev_media" > */}
                            <div className="rev_media">
                                <div className="media_left"><i className="two-sp"></i></div>
                                <div className="contentarea">
                                    <b className="fz-17 fw3 revfincolor">Select</b>
                                    <p className="mgt-10 fz-12 lcolor">Select the loan that next suits your need. Get an
                                        additional
                                        Revloan credit line.</p>
                                </div>
                            </div>
                            {/* </a> */}
                        </li>
                        <li className={`${this.state.activecl == 3 ? 'activecl' : ''}`}>
                            {/* <a href="javascript:void(0)" className="rev_media" > */}
                            <div className="rev_media">
                                <div className="media_left"><i className="three-sp"></i></div>
                                <div className="contentarea">
                                    <b className="fz-17 fw3 revfincolor">Spend</b>
                                    <p className="mgt-10 fz-12 lcolor">Get money in your account within minutes, so
                                        start
                                        spending!</p>
                                </div>
                            </div>
                            {/* </a> */}
                        </li>
                    </ul>

                    <div className="d-block d-md-none mysmallSlider">
                        <Swiper {...params} >
                            <div prop="one">
                                <li className="xs-slider">
                                    {/* <a href="javascript:void(0)" className="rev_media" > */}
                                    <div className="rev_media">
                                        <div className="media_left"><i className="one-sp"></i></div>
                                        <div className="contentarea">
                                            <b className="fz-17 fw3 revfincolor">Apply</b>
                                            <p className="mgt-10 fz-12 lcolor">Download our App to complete the
                                                application process.
                                                From starting to getting a decision usually takes about
                                                10 minutes!</p>
                                        </div>
                                    </div>
                                    {/* </a> */}
                                </li>
                            </div>

                            <div>
                                <li>
                                    {/* <a href="javascript:void(0)" className="rev_media" > */}
                                    <div className="rev_media">
                                        <div className="media_left"><i className="two-sp"></i></div>
                                        <div className="contentarea">
                                            <b className="fz-17 fw3 revfincolor">Select</b>
                                            <p className="mgt-10 fz-12 lcolor">Select the loan that next suits your
                                                need. Get an additional
                                                Revloan credit line.</p>
                                        </div>
                                    </div>
                                    {/* </a> */}
                                </li>
                            </div>

                            <div>
                                <li>
                                    {/* <a href="javascript:void(0)" className="rev_media"> */}
                                    <div className="rev_media">
                                        <div className="media_left"><i className="three-sp"></i></div>
                                        <div className="contentarea">
                                            <b className="fz-17 fw3 revfincolor">Spend</b>
                                            <p className="mgt-10 fz-12 lcolor">Get money in your account within minutes,
                                                so start
                                                spending!</p>
                                        </div>
                                    </div>
                                    {/* </a> */}
                                </li>
                            </div>
                        </Swiper>
                    </div>


                    <div className="app_icon">
                        <ul className="myflex flex-between">
                            <li>
                                <a href="https://apps.apple.com/in/app/revfin/id1454364758" target="_blank">
                                    <div className="icon_body">
                                        <div className="icon-left pro1"></div>
                                        <div className="icon-content">
                                            <p>Available on </p>
                                            <h4><b>App Store</b></h4>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://play.google.com/store/apps/details?id=com.revfin_ptech18"
                                   target="_blank">
                                    <div className="icon_body">
                                        <div className="icon-left pro2"></div>
                                        <div className="icon-content">
                                            <p>Available on </p>
                                            <h4><b>Google play</b></h4>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default Howdoes;



// WEBPACK FOOTER //
// ./src/components/work.js